import { PROFILE_KEY } from '../../../../../models/profile/constants'
import { updateProfileAction } from '../update'
import { getCurrentOrCustomerProfileSelect } from '../../selectors/get-current-or-customer'
import { getWeightUnitProfileSelect } from '../../selectors/get-weight-unit'
import { PROFILES_ACTION } from '../../constants'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import { getKgsWeightUtil } from '../../../../weight/utils/get-kgs'
import { getLbsWeightUtil } from '../../../../weight/utils/get-lbs'
import { UNIT } from '../../../../../constant'

export function updateWeightUnitProfileAction (value) {
  return (dispatch, getState) => {
    const weightUnit = getWeightUnitProfileSelect(getState())
    if (weightUnit === value) {
      return
    }
    const profile = getCurrentOrCustomerProfileSelect(getState())
    const weight = getValueReduxUtil(profile, PROFILE_KEY.WEIGHT)
    const updates = {
      [PROFILE_KEY.WEIGHT_UNIT]: value
    }
    if (weight != null && value === UNIT.METRIC) {
      updates[PROFILE_KEY.WEIGHT] = Math.round(getKgsWeightUtil(weight))
    } else if (weight != null) {
      updates[PROFILE_KEY.WEIGHT] = Math.round(getLbsWeightUtil(weight))
    }
    dispatch(updateProfileAction({
      type: PROFILES_ACTION.UPDATE_WEIGHT_UNIT,
      payload: {
        updates
      }
    }))
  }
}
